import { intl } from "LocaleWrapper";
import { locationSelectOptionSchema } from "view/locations/utils/location.schema";
import z from "zod";
import { FullOrEmpty } from "./ContainerUtils";
import { ZodSchema } from "@validation/utils/schemaUtils";

export const containerTypeSelectOptionSchema = z.object({
	isoTypeCode: z.string(),
});

export const containerBulkEditSchema = z.object({
	containerNumber: z.string().refine((val) => isValidContainerNumber(val), {
		message: intl.formatMessage({ id: "INVALID_CONTAINER_NUMBER" }),
	}),
	containerType: containerTypeSelectOptionSchema.nullable(),
	isEmpty: z.enum(FullOrEmpty).nullable(),
	temperature: z.number().min(-100).max(100).nullable(),
	weight: z.number().min(0).max(99999.999).nullable(),
	loadedWeight: z.number().min(0).max(99999.999).nullable(),
	grossWeight: z.number().min(0).max(99999.999).nullable(),
	verifiedGrossWeight: z.number().min(0).max(99999.999).nullable(),
	sealNumber: z.string().max(50),
	damage: z.string().max(255),
	loadingLocation: locationSelectOptionSchema.nullable(),
	loadingReference: z.string().max(50),
	dischargingLocation: locationSelectOptionSchema.nullable(),
	dischargingReference: z.string().max(50),
	canSkipperEditLoadedTimestamp: z.boolean(),
	canSkipperEditDischargedTimestamp: z.boolean(),
});

export type ContainerBulkEditSchemaInput = z.input<typeof containerBulkEditSchema>;
export type ContainerBulkEditSchemaOutput = z.output<typeof containerBulkEditSchema>;

export const containerLoadedOrDischargedSchema = z.object({
	timestamp: ZodSchema.requiredField(z.number()),
});

export type containerLoadedOrDischargedSchemaInput = z.input<typeof containerLoadedOrDischargedSchema>;
export type containerLoadedOrDischargedSchemaOutput = z.output<typeof containerLoadedOrDischargedSchema>;

const charValues = {
	0: 0,
	1: 1, 2: 2, 3: 3, 4: 4, 5: 5, 6: 6, 7: 7, 8: 8, 9: 9, A: 10,
	B: 12, C: 13, D: 14, E: 15, F: 16, G: 17, H: 18, I: 19, J: 20, K: 21,
	L: 23, M: 24, N: 25, O: 26, P: 27, Q: 28, R: 29, S: 30, T: 31, U: 32,
	V: 34, W: 35, X: 36, Y: 37, Z: 38,
};

export function isValidContainerNumber(value: string) {
	if (value === "") {
		return true;
	}

	const number = value.replace(/([_ -])/g, "");

	if (number.length !== 11 || !/[A-Z]{4}[0-9]{7}/.test(number)) {
		return false;
	}

	let check = 0;

	for (let i = 0; i < 10; i++) {
		const v = charValues[number[i as keyof typeof number] as keyof typeof charValues];
		check = check + (v * Math.pow(2, i));
	}

	return (check % 11) % 10 === charValues[number[10] as keyof typeof charValues];
}
